import {
  ATTENDANCE_EVENT_CLEARED,
  ATTENDANCE_EVENT_STARTED,
} from "./actionTypes";
import { prunePendingEvents } from "@utils/attendance";

/**
 * Persisted (see store whitelist). One fact lives here: the idempotency key
 * (`client_event_id`) of each mark in progress, keyed by subject + IST day + event type
 * (see pendingEventKey). Written BEFORE the native screen opens and cleared once
 * the server accepts the photo, so a relaunch after a process death or a
 * dropped upload re-sends the same key and gets the same row back.
 */
const initState = {
  pending: {},
};

export const actions = {
  /**
   * `today` (IST `YYYY-MM-DD`) prunes keys left over from earlier days.
   * @param {{ key: string, clientEventId: string, today?: string }} payload
   */
  eventStarted({ key, clientEventId, today }) {
    return {
      type: ATTENDANCE_EVENT_STARTED,
      payload: { key, clientEventId, today },
    };
  },
  /** @param {string} key */
  eventCleared(key) {
    return { type: ATTENDANCE_EVENT_CLEARED, payload: { key } };
  },
};

const reducer = (state = initState, action) => {
  // Older builds persisted a different shape; tolerate it.
  const pending = state?.pending ?? {};
  switch (action.type) {
    case ATTENDANCE_EVENT_STARTED:
      return {
        ...state,
        pending: {
          ...(action.payload.today
            ? prunePendingEvents(pending, action.payload.today)
            : pending),
          [action.payload.key]: action.payload.clientEventId,
        },
      };
    case ATTENDANCE_EVENT_CLEARED: {
      const rest = { ...pending };
      delete rest[action.payload.key];
      return { ...state, pending: rest };
    }
    default:
      return state;
  }
};
reducer.initialState = initState;
export default reducer;
